export class AIReportContainer extends HTMLElement {
    $thumbsUpDownRater = null;

    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.init();
    }

    init()
    {
        this.initEventHandlers();
        this.updateReportsViewed();
    }

    initEventHandlers()
    {
        const reportContainer = this.querySelector('.reports');
        const reportLinks = reportContainer.querySelectorAll('td.download-link a');
        this.updateReportsViewed.bind(this);
        reportLinks.forEach((link) => {
            const row = link.closest('tr');
            if (!row.classList.contains('deleted')) {
                link.addEventListener('click', (event) => {
                    this.updateReportsViewed(event);
                });
            }
        });

        const deleteRptLinks = reportContainer.querySelectorAll('td.delete-icon a');
        deleteRptLinks.forEach((link) => {
            link.addEventListener('click', this.deleteReport.bind(this));
        });

        this._boundOnPopState = this.onPopState.bind(this);
        window.addEventListener('popstate', this._boundOnPopState);
    }

    disconnectedCallback()
    {
        window.removeEventListener('popstate', this._boundOnPopState);
    }

    deleteReport(event)
    {
        event.preventDefault();
        const target = event.currentTarget;
        const caseID = target.dataset.case_id || 0;
        const caseDocID = target.dataset.case_doc_id || 0;
        const isConsolidated = caseDocID > 0 ? 0 : 1;
        const formData = new FormData();
        if (isConsolidated) {
            formData.append('case_id', caseID);
        } else {
            formData.append('case_doc_id', caseDocID);
        }
        formData.append('action', 2); // action 2 is delete
        toastr.info('Deleting report...');

        fetch('/ca/do/u', {
            method: 'POST',
            body: formData,
            expect: 'json'
        }).then(response => {
            if (response.status === 200) {
                const row = target.closest('tr');
                row.classList.add('deleted');
                const downloadLink = row.querySelector('.download-link a');
                if (downloadLink) {
                    downloadLink.remove();
                }
                const thumbsUpDown = row.querySelector('thumbs-up-down-rater');
                if (thumbsUpDown) {
                    thumbsUpDown.parentNode.style.cursor = 'default';
                    thumbsUpDown.remove();
                }

                const reportTypelink = row.querySelector('.report-type a');
                if (reportTypelink) {
                    reportTypelink.parentNode.textContent = reportTypelink.textContent;
                    reportTypelink.remove();
                }

                const deleteIcon = row.querySelector('.delete-icon a');
                if (deleteIcon) {
                    deleteIcon.remove();
                }
                const deletedCol = row.querySelector('.deleted .deleted-text');
                if (deletedCol) {
                    const now = new Date().toLocaleDateString('en-US', {
                        weekday: 'short',
                        month: 'short',
                        day: '2-digit',
                        year: 'numeric'
                    });
                    deletedCol.textContent = `Deleted on ${now}`;
                }
                toastr.success('Report deleted successfully.');
                // Update the report count in the header
                this.updateReportsViewed();
            } else {
                console.error('Failed to delete report:', response);
                toastr.error('Failed to delete report. Please try again later.');
            }
        });
    }

    updateReportsViewed(event)
    {
        // first update the row of dicom clicked, to mark it as viewed
        if (event) {
            const target = event.target;
            const targetRow = target.closest('tr');
            targetRow.classList.add('viewed');
        }

        // now count all the viewed rows in the table
        const allRows = this.querySelectorAll('tr.rpt:not(.deleted)');
        const nonDeletedCount = allRows.length;

        const viewedCount = this.querySelectorAll('tr.rpt.viewed:not(.deleted)');
        const unViewedCount = nonDeletedCount - viewedCount.length;

        // now update the report count in the header
        const reportCountAmount = this.querySelector('.report-count-amount');
        if (unViewedCount > 0) {
            reportCountAmount.textContent = unViewedCount;
        } else {
            reportCountAmount.style.display = 'none';
        }
    }

    onPopState(event)
    {
        event.stopImmediatePropagation();
        const backBtn = this.querySelector('.closeLevel');
        if (backBtn) {
            backBtn.click();
        }
    }
}

customElements.define('ai-report-container', AIReportContainer);